// 目录数组的id值所对应的url跳转地址
export const menuListIdUrl = {
  1: "", //
  2: "", //
  3: "", //
  4: "", //
  5: "", // 图书介绍
  6: "/layout/list/highSchoolBooks", // 高中书系
  7: "/layout/list/middleSchoolBooks", // 初中书系
  8: "/layout/list/primarySchoolBooks", // 小学书系
  9: "", //
  10: "", //
  11: "", //
  12: "", //
  13: "", //
  14: "", //
  15: "/layout/list/teacherHand", // 教师助手
  16: "", //
  17: "/layout/list/home", // 首页
  18: "/layout/list/addedServices", // 增值服务
  19: "/layout/list/boutiqueTaobaoQuestions", // 精品淘题
  20: "/layout/list/studentWorld", // 学生天地
  21: "/layout/list/parentSchool", // 家长学堂
  22: "", // 经销授权
  23: "/layout/list/walkIntroTianLi", // 走进天利
  24: "/layout/list/research", // 课题研究
  25: "/layout/list/teachingActivities", // 教研活动
  26: "/layout/list/KnowledgeDrivenGoods", // 知识干货
  27: "/layout/list/onlineLearning", // 在线学习
  28: "/layout/list/thematicActivities", // 专题活动
  29: "/layout/list/worksDisplay", // 作品展示
  30: "/layout/list/talkPolicies", // 说政策
  31: "/layout/list/checkTheProcess", // 看流程
  32: "/layout/list/fractionBar", // 分数线
  33: "/layout/list/findAUniversity", // 找大学
  34: "/layout/list/parentChildGarden", // 亲子园地
  35: "/layout/list/authorizedOnlineShop", // 授权网点
  36: "/layout/list/offlineAgent", // 线上代理
  40: "/layout/list/projectAchievements", // 研究成果
  // 后端没有返回课题成果、到底是线上代理还是线下代理
  43: "/layout/list/personalCenter/personalInfor", // 个人中心
  44: "/layout/list/testAndVerify", // 正版验证
  45: "/layout/list/bookCorrection", // 图书反馈
  46: "/layout/list/fundingPublicWelfareProjects", // 新增 资助教研公益项目专题页
};

// 获取某个页面的轮播图数组
export function getSlideArr(path) {
  let keyName = null;
  // 通过遍历，拿到某个页面的url对应的目录数组的id值
  for (const key in menuListIdUrl) {
    if (Object.prototype.hasOwnProperty.call(menuListIdUrl, key)) {
      keyName = menuListIdUrl[key] === path ? key : keyName;
    }
  }
  // 获取本地存储的全部轮播图对象
  let slideObj = JSON.parse(localStorage.getItem("slideObj"));
  // 如果存在轮播图数组，那么正常返回轮播图数组，否则返回空数组
  let slideArr = Array.isArray(slideObj[keyName]) ? slideObj[keyName] : [];
  // 返回内容
  return slideArr;
}

// 获取某个页面的url对应的目录数组的id值
export function getUrlId(path) {
  let keyName = null;
  // 通过遍历，拿到某个页面的url对应的目录数组的id值
  for (const key in menuListIdUrl) {
    if (Object.prototype.hasOwnProperty.call(menuListIdUrl, key)) {
      keyName = menuListIdUrl[key] === path ? key : keyName;
    }
  }
  return keyName;
}

// 获取某个页面的url对应的目录数组的目录子级
export function getMenuChildren(path) {
  // 获取id值
  let urlId = getUrlId(path);
  // 获取全部目录
  let menuList = JSON.parse(localStorage.getItem("menuList")) ?? [];
  // 获取id值所对应的目录
  let menuItem = menuList.find((item) => {
    return Number(item.id) === Number(urlId);
  });
  // 获取目录的children子级目录
  let childrenList = menuItem.children || [];
  // 返回子级目录
  return childrenList;
}

// 通过id获得对应的url地址
export function useIdGetUrl(id) {
  return menuListIdUrl[id]
}
